import {Contractor} from '@/interfaces/contractor'

export const state = {
    list: [],
    current: null,
    reviewContractor: null
}

export type ContractorState = {
    list: Contractor[];
    current: Contractor;
    reviewContractor: Contractor;
}